export default {
  tabs: {
    home: 'Koti',
    menu: 'Valikko',
    orders: 'Tilaukset',
  },
};
